import React from 'react';
import Modal from '../../molecules/Modal';
import './index.css';

export interface NegotiationMemoPreviewModalProps {
  isOpen: boolean;
  negotiationMemo: string;
  onClose: () => void;
}

/**
 * 商談メモプレビューモーダル
 */
const NegotiationMemoPreviewModal: React.FC<NegotiationMemoPreviewModalProps> = ({ isOpen, negotiationMemo, onClose }) => {
  return (
    <Modal
      open={isOpen}
      onClose={() => onClose()}
      hasFade={false}
      onBackdropClick={onClose}
      onEscapeKeyDown={onClose}
      surfaceClassName='u-mv-auto negotiation-memo-preview-modal'
      data-testid='negotiation-memo-preview-modal'>
      <Modal.Header hasCloseButton data-testid='negotiation-memo-preview-modal-title'>
        商談メモ
      </Modal.Header>
      <Modal.Content className='u-p16 content' data-testid='negotiation-memo-preview-modal-content'>
        {negotiationMemo}
      </Modal.Content>
    </Modal>
  );
};

export default NegotiationMemoPreviewModal;
